// Use CreditCardDetector from Cleave.js to detect credit card type
// https://github.com/nosir/cleave.js/blob/master/src/shortcuts/CreditCardDetector.js
import Cleave from "cleave.js";
const getInfo = Cleave.CreditCardDetector.getInfo; // returns { type, blocks }

export default val => {
  return val ? getInfo(val).type : null;
};
